export default {
  activity: {
    title: 'Student Activities',
  },
  sitewide: {
    title: 'Schoolwide Practices',
  },
  educator: {
    title: 'Educator Practices',
  },
}
